/**
 * @file contractDraft.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-22
 * @modified 2026-10-22
 * @description Make a draft contract live from a pricing table's right-click
 *              and three-dots menus (Cam, 2026-10-22). The whole contract goes
 *              live together — every row of a product group — and the server
 *              first checks each row's own dates against live contracts for the
 *              same product and customer, refusing with the overlap named.
 */

import { API_URL } from '../config';

/** PATCH /api/pricing/contracts/:id/promote. Throws with the server's words. */
export async function makeContractLive(id) {
  const r = await fetch(`${API_URL}/api/pricing/contracts/${id}/promote`, {
    method: 'PATCH',
    credentials: 'include'
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
  return data;
}

/**
 * The menu item. Always present (a row's actions never change count); greyed
 * on a contract that is already live.
 */
export const makeLiveAction = ({ draft, onClick, subject = 'contract' }) => ({
  key: 'make-live',
  icon: 'publish',
  label: 'Make live',
  disabled: !draft,
  title: draft
    ? `Make this draft ${subject} live — checked against live contracts for overlapping dates first`
    : `This ${subject} is already live`,
  onClick
});
